// Lets the shared auth module talk to the Firebase SDK without importing it.
// The platform (web) registers its implementation once at startup via
// setFirebaseBridge(); sagas read it through getFirebaseBridge().
//   getIdToken: () => Promise<string | null>   (SDK refreshes if near expiry)
//   signOut:    () => Promise<void>
let bridge = { getIdToken: null, signOut: null };

export const setFirebaseBridge = impl => {
  bridge = { ...bridge, ...impl };
};

export const getFirebaseBridge = () => bridge;